import React from 'react';
import DataTable from '../../components/dataTable';
import Button from '../../components/button';
import I18nMessage from '../../components/I18nMessage';

const CustomerDeviceTable = (props) => {
    const {
        onPressBack,
        list,
    } = props;

    return (
        <DataTable
            list={list}
            showGroupButtons={false}
            keyField={'id'}
            headers={[
                {title: 'sharedName', field: 'name', dataSort: true},
                {title: 'deviceImei', field: 'uniqueId', dataSort: true},
                {title: 'deviceModel', field: 'model', dataSort: true},
                {title: 'groupDialog', field: 'groupName', dataSort: true},
                {title: 'sharedDisabled', field: 'disabled', dataSort: true},
            ]}
            extraHeaderEl={ (row, _) => <Button
                className={'outline'}
                color={'theme'}
                size={'sm'}
                onClick={onPressBack}
            >
                <i className="fas fa-arrow-left"/> <I18nMessage id="sharedBack"/>
            </Button>}
        />);
};

export default CustomerDeviceTable;
